import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { WishlistEmptyComponent } from './ui/components/wishlist-empty/wishlist-empty.component';
import { WishlistIconComponent } from './ui/components/wishlist-icon/wishlist-icon.component';
import { WishlistItemComponent } from './ui/components/wishlist-item/wishlist-item.component';
import { WishlistFeatureCoreModule } from './wishlist-feature.core.module';

import { ProductCartComponent } from '@shared/product/modals/product-added-to-cart-modal/product-cart/product-cart.component';
import { ProductCommonModule } from '@shared/product/product-common.module';
import { ShopcartWishlistModule } from '@shared/shopcart/shopcart-wishlist.module';
import { SvgIcon2Component } from '@ui/svg-icon/svg-icon.component';

@NgModule({
    declarations: [
        WishlistEmptyComponent,
        WishlistIconComponent,
        WishlistItemComponent,
    ],
    imports: [
        CommonModule,
        ProductCartComponent,
        ProductCommonModule,
        TranslateModule.forChild(),
        ShopcartWishlistModule,
        SvgIcon2Component,
        WishlistFeatureCoreModule,
    ],
    providers: [
        DatePipe,
    ],
    exports: [
        WishlistEmptyComponent,
        WishlistIconComponent,
        WishlistItemComponent,
    ],
})

/**
 * Módulo de la capa presentacional de la Wishlist
 */
export class WishlistFeatureUiModule {
    public get wishlistIconComponent() {
        return WishlistIconComponent;
    }
}
